"use client";
import { Suspense } from "react";
import dynamic from "next/dynamic";

import { BookDetailType } from "@/lib/schema";

import { AudioBookPlayer } from "./audio-book-player";

const PDFViewer = dynamic(() => import("./pdf-viewer"), { ssr: false });

export function SwitchBookViewer({
  readType,
  book,
}: {
  readType?: "read" | "listen";
  book: BookDetailType;
}) {
  if (readType === "read" || (!readType && book.book_type === 1))
    return (
      <Suspense>
        <PDFViewer
          pdfUrl="https://morth.nic.in/sites/default/files/dd12-13_0.pdf"
          pdfTitle={book.title}
        />
      </Suspense>
    );
  return <AudioBookPlayer book={book} />;
}
